"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BotIcon = function BotIcon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.125 11.125H10.875C9.83947 11.125 9 11.9645 9 13V21.75C9 22.7855 9.83947 23.625 10.875 23.625H22.125C23.1605 23.625 24 22.7855 24 21.75V13C24 11.9645 23.1605 11.125 22.125 11.125Z",
    stroke: "#92628F",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.3125 18H13.6875C12.8246 18 12.125 18.6996 12.125 19.5625C12.125 20.4254 12.8246 21.125 13.6875 21.125H19.3125C20.1754 21.125 20.875 20.4254 20.875 19.5625C20.875 18.6996 20.1754 18 19.3125 18Z",
    stroke: "#92628F",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.5 11.125V8",
    stroke: "#92628F",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.0625 16.125C13.5803 16.125 14 15.7053 14 15.1875C14 14.6697 13.5803 14.25 13.0625 14.25C12.5447 14.25 12.125 14.6697 12.125 15.1875C12.125 15.7053 12.5447 16.125 13.0625 16.125Z",
    fill: "#92628F"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.9375 16.125C20.4553 16.125 20.875 15.7053 20.875 15.1875C20.875 14.6697 20.4553 14.25 19.9375 14.25C19.4197 14.25 19 14.6697 19 15.1875C19 15.7053 19.4197 16.125 19.9375 16.125Z",
    fill: "#92628F"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "16",
    cy: "16",
    r: "16",
    fill: "#92628F",
    fillOpacity: "0.3"
  }));
};

var _default = BotIcon;
exports["default"] = _default;